import { render } from "./work-schedule.html?vue&type=template&id=23dc0962&scoped=true&ts=true"
import script from "./work-schedule.ts?vue&type=script&lang=ts"
export * from "./work-schedule.ts?vue&type=script&lang=ts"

import "./work-schedule.scss?vue&type=style&index=0&id=23dc0962&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dc0962"]])

export default __exports__